export default __webpack_public_path__ + "static/media/carvest-time-featured-image.ce6f737f.png";